import api from '../services/api';
import { addSpinner } from '../utils/add-spinner';
import { $Q, $Qll } from '../utils/query-selector';
import { dataToggle } from '../utils/toggle-dataset';
import {
  updateCartItems,
  updatetotalPrice,
  updateUpsell,
  updateCartbutton,
  updatePriceItem,
  updateQuantity,
} from './update-cart';
import { updateSyncCart } from "../components/cart-services-async";
import { debounce } from '../utils/debounce';

const CART_SECTION = 'side-cart,cart-page,cart-upsell,cart-total';
let wait = false;

/**
 * Add products in cart
 * @param {event} event -Event submit from add to cart form
 * @param {event} event -Event submit from add to cart form
 */
// eslint-disable-next-line complexity, max-lines-per-function
const addProducts = async (event) => {
  const initLoading = processingBtnAdd(event);
  const valueCount = $Q('#quantity', event.currentTarget)
    ? $Q('#quantity', event.currentTarget).value
    : 1;
  const itemId = $Q("input[name='id']", event.target).value;

  const cartParams = {
    items: [
      {
        id: itemId,
        quantity: valueCount,
      },
    ],
    sections: CART_SECTION,
  };

  const data = await api.addToCart(cartParams);
  const { sections, status } = await data;

  if (initLoading) {
    const [submitter, content] = initLoading;
    submitter.textContent = content;
  }

  if (status === 422) {
    cartOutStockAlert(data);
    return;
  }

  if (!sections) return null;

  const onCart = window.location.href.includes('cart');

  if (event.target.dataset.form !== 'upsell' && !onCart) {
    dataToggle($Q('#shopify-section-side-cart'), true);
  }

  if (onCart) {
    const productModal = $Q('#product-modal');
    const isProductModalActive = productModal.getAttribute('data-active') === 'true';
    if (isProductModalActive) {
      dataToggle(productModal, true);
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  updateCartItems(sections['side-cart']);
  updateCartbutton(sections);
  updatetotalPrice(sections['side-cart']);
  updateUpsell(sections);
};

const processingBtnAdd = (event) => {
  const submitter = $Q('.btn-cart-js', event.target);
  if (!submitter) {
    return;
  }

  const content = submitter.textContent;
  addSpinner('.btn-cart-js', event.target);

  return [submitter, content];
};

const cartOutStockAlert = (request) => {
  if (wait) return;

  wait = true;
  const message = $Q('#error-out-stock');
  const info = $Q('span', message);

  if (request && request.data) {
    info.textContent = request.data.description || request.data.message;
  } else {
    info.textContent = message.dataset.message
  }

  message.classList.remove('hidden');

  setTimeout(() => {
    message.classList.add('hidden');
    wait = false;
  }, 2000);
};

/**
 * Listen if add to cart form is submited
 * if add to cart form is submited add products in cart
 *
 * if you want to add the event to a single repeated element,
 * you can use only the form selector for example.
 * but if you have several events on the same page
 * that load at different times, you can pass the parent of
 * the element so that it only loads that event and
 * not the ones that are loaded.
 * @param {string} formQuery - className reference in form add-to-cart
 *
 * To active this feature - ADD className 'add-cart-js' in form product
 * */
export const btnAddToCart = (formQuery, parent = null) => {
  const addForms = $Qll(formQuery, parent);
  if (addForms.length === 0) return;

  return addForms.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addProducts(e);
    });
  });
};

/**
 * Update quantity for each item in cart
 * @param {number} id Product ID
 * @param {number} quantity new quantity
 */
export const updateCart = async (line, quantity, id) => {
  const priceNode = $Q(`#price-${id}`);
  const priceBefore = priceNode.textContent;
  const quantityBefore = $Q(`.item-cart-js[data-index="${line}"]`).dataset.quantity

  const cartParams = {
    line,
    quantity,
    sections: CART_SECTION,
  };

  addSpinner(`#price-${id}`);
  const data = await api.changeCart(cartParams);
  const { sections, status } = await data;

  if (status === 422) {
    priceNode.textContent = priceBefore;
    updateQuantity(id, quantityBefore);
    cartOutStockAlert(data);

    return false;
  }

  if (!sections) return false;

  if (Number(quantity) === 0) {
    updateCartItems(sections['side-cart']);
    updateCartbutton(sections);
    updatetotalPrice(sections['side-cart']);
    updateUpsell(sections);
  } else {
    updatePriceItem(sections['side-cart'], id);
    updateCartbutton(sections);
    updatetotalPrice(sections['side-cart']);
  }
  // updateSyncCart();

  return true;
};

/**
 * Event onChange in the cart item
 */
export const onChangeItemCart = (scope = null) => {
  const input = $Q('.item-cart-js', scope);

  input.addEventListener(
    'change',
    debounce(async () => {
      const udpate = await updateCart(
        input.dataset.index, input.value, input.id,
      );

      if (udpate) {
        input.setAttribute('data-quantity', input.value)
      }
    }, 500).bind(this),
  )
};

/**
 * Delete item in cart
 * listen if delete button is clicked
 * if is clicked, update cart with quantity 0
 */
export const deleteItem = (parent = null) => {
  const deleteIcon = $Qll('.item-delete', parent);

  if (deleteIcon) {
    deleteIcon.forEach((element) => {
      const {
        dataset: { id, index },
      } = element;
      element.addEventListener('click', () => {
        updateCart(index, 0, `${id}-${index}`);
      });
    });
  }
};

/**
 * update cart local with remote metafield async
 * @param {dataUpdate} object - items cart adding
 */
// eslint-disable-next-line complexity
export const updateCartLocalWithRemoteItems = async (dataUpdate) => {

  const cartParams = {
    objectData: dataUpdate,
    sections: CART_SECTION,
  };

  const { sections } = await api.updateCartAll(cartParams);

  if (!sections) return null;

  updateCartItems(sections['side-cart']);
  updateCartbutton(sections);
  updatetotalPrice(sections['side-cart']);
  updateUpsell(sections);
};
